(() => {
  'use strict';
  const initialize = () => {
    document.querySelectorAll('.atlas-ritual').forEach(section => {
      if (section.dataset.ritualReady) return;
      section.dataset.ritualReady = 'true';
      const photo = section.querySelector('.atlas-ritual-photo img');
      const steps = [...section.querySelectorAll('[data-ritual-image]')];
      if (!photo || !steps.length) return;
      let revision = 0;
      const show = step => {
        const request = ++revision;
        const next = new Image();
        next.onload = () => {
          if (request !== revision || !section.isConnected) return;
          const changed = photo.getAttribute('src') !== step.dataset.ritualImage;
          photo.removeAttribute('srcset');
          photo.removeAttribute('sizes');
          photo.src = step.dataset.ritualImage;
          photo.alt = step.dataset.ritualAlt || '';
          if (changed && !matchMedia('(prefers-reduced-motion:reduce)').matches && photo.animate) {
            photo.getAnimations().forEach(animation => animation.cancel());
            photo.animate([{ opacity: .2 }, { opacity: 1 }], { duration: 450, easing: 'ease-out' });
          }
        };
        // Keep the current photo if a replacement fails to load.
        next.src = step.dataset.ritualImage;
      };
      steps.forEach(step => step.addEventListener('toggle', () => {
        if (!step.open) return;
        steps.forEach(other => { if (other !== step) other.open = false; });
        show(step);
      }));
      show(steps.find(step => step.open) || steps[0]);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:block:select', event => {
    const step = event.target.closest('.atlas-ritual-step');
    if (step) step.open = true;
  });
})();
